import { Link } from "react-router-dom";
import SoftButton from "components/SoftButton";
import { useTranslation, Trans } from "react-i18next";
import { Box, Card, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import logo from "assets/images/logo.png";
import LanguageSwitcher from "../../../reusableComponents/LanguageSwitcher/LanguageSwitcher";
import { useTheme } from "@mui/material/styles";

function Confirmation() {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const { t } = useTranslation(["confirmation"]);
  const currentLang = i18n.language;
  const dir = i18n.dir();

  const important = t("content.important");
  const hours = t("content.hours");
  const backLink = `/${currentLang}/authentication/sign-in`;

  const [animateCard, setAnimateCard] = useState(false);
  const [animateTitle, setAnimateTitle] = useState(false);
  const [animateImage, setAnimateImage] = useState(false);
  const [animateLogo, setAnimateLogo] = useState(false);

  useEffect(() => {
    setTimeout(() => setAnimateLogo(true), 300);
    setTimeout(() => setAnimateImage(true), 400);
    setTimeout(() => setAnimateTitle(true), 500);
    setTimeout(() => setAnimateCard(true), 700);
  }, []);

  return (
    <>
      <style>
        {`
          @keyframes fadeSlideIn {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes scan {
            0% { top: 0; }
            50% { top: 100%; }
            100% { top: 0; }
          }
        `}
      </style>

      <Grid container sx={{ minHeight: "100vh", overflow: "hidden" }} dir={dir}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            p: 5,
            backgroundColor: "#ffffff",
            position: "relative",
            }}
            >
          <Box
            sx={{
              position: "absolute",
              top: theme.spacing(2),
              left: theme.spacing(2),
              right: theme.spacing(2),
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              zIndex: 10,
            }}
          >
            <Box
              sx={{
                opacity: animateLogo ? 1 : 0,
                transform: animateLogo ? "translateY(0)" : "translateY(-10px)",
                transition: "all 0.8s ease",
              }}
            >
              <img src={logo} alt="YaiGlobal Logo" style={{ height: 48 }} />
            </Box>
            <LanguageSwitcher />
          </Box>

          <Box sx={{ width: "100%", maxWidth: 480 }}>
  <Card
    elevation={6}
    sx={{
      borderRadius: 4,
      px: 5,
      py: 6,
      backdropFilter: "blur(12px)",
      backgroundColor: "rgba(255, 255, 255, 0.65)",
      border: "1px solid rgba(255, 255, 255, 0.4)",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
      opacity: animateCard ? 1 : 0,
      transform: animateCard ? "translateY(0)" : "translateY(10px)",
      transition: "all 0.7s ease",
      textAlign: "center"
    }}
  >
    <Typography
      variant="h4"
      fontWeight="bold"
      sx={{
        background: "linear-gradient(to right, #d946ef, #ec4899)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        mb: 1,
        opacity: animateTitle ? 1 : 0,
        transform: animateTitle ? "translateX(0)" : "translateX(-10px)",
        transition: "all 0.7s ease",
      }}
    >
      {t("content.title")}
    </Typography>

    <Typography
      variant="body2"
      color="textSecondary"
      sx={{
        mb: 3,
        opacity: animateTitle ? 1 : 0,
        transform: animateTitle ? "translateX(0)" : "translateX(-10px)",
        transition: "all 0.8s ease",
      }}
    >
      {t("content.description")}
    </Typography>

    <Typography variant="body2" color="textSecondary">
      <strong>{important}</strong>{" "}
      <Trans
        ns="confirmation"
        i18nKey="content.note"
        values={{ hours }}
        components={[<></>, <strong key={"hours"}> {hours} </strong>]}
      />
    </Typography>

    <SoftButton
      component={Link}
      to={backLink}
      variant="gradient"
      color="primary"
      fullWidth
      sx={{ mt: 3 }}
    >
      {t("content.backToLogin")}
    </SoftButton>
  </Card>
</Box>

        </Grid>
        <Grid item md={6} sx={{ display: { xs: "none", md: "block" }, position: "relative", overflow: "hidden" }}>
            <Box
                sx={{
                width: "100%",
                height: "100%",
                background: "linear-gradient(135deg, rgba(217,70,239,0.9), rgba(126,34,206,0.9))",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: animateImage ? 0.8 : 0,
                transition: "opacity 1s ease",
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        p: 4,
                        maxWidth: 500,
                        backgroundColor: "rgba(255,255,255,0.1)",
                        borderRadius: 4,
                        border: "1px solid rgba(255,255,255,0.2)",
                        animation: animateImage ? "fadeSlideIn 1s ease forwards" : "none",
                        textAlign: "center"
                    }}
                    >
                    <Typography variant="h5" fontWeight="bold" sx={{ color: "#fff", mb: 2 }}>
                        {t("content.welcomePanel.headline")}
                    </Typography>

                    <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.85)", mb: 3 }}>
                        {t("content.welcomePanel.subtext")}
                    </Typography>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {t("content.welcomePanel.features", { returnObjects: true }).map((feature, idx) => (
                        <Box
                            key={idx}
                            sx={{
                            px: 2,
                            py: 0.5,
                            borderRadius: 50,
                            backgroundColor: "rgba(255,255,255,0.2)",
                            fontSize: "0.875rem",
                            color: "#fff",
                            textAlign: "center"
                            }}
                        >
                            {feature}
                        </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
            <Box
                component="svg"
                xmlns="http://www.w3.org/2000/svg"
                sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.2 }}
            >
                <defs>
                <pattern id="circuit-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
                    <path
                    d="M10,10 L40,10 L40,40 L70,40 L70,70 L40,70 L40,40 M60,10 L90,10 L90,40 M10,30 L10,60 L30,60 M10,80 L40,80 L40,90 L70,90 M60,30 L60,60 L90,60 L90,90"
                    fill="none"
                    stroke="white"
                    strokeWidth="1"
                    />
                </pattern>
                </defs>
                <rect x="0" y="0" width="100%" height="100%" fill="url(#circuit-pattern)" />
            </Box>
        </Grid>
    </Grid>
    </>
  );
}

export default Confirmation;